import { Injectable } from '@angular/core';
import { FieldAgentClient, SmartView, SmartViewColumn } from 'ep-bt-field-agent-proxy';
import { Router, NavigationExtras } from '@angular/router';
import { IEpShellMenuPanelModel } from '@epicor/kinetic';
import { EpbtFieldAgentService } from '../services/epbt-field-agent.service';

@Injectable({
  providedIn: 'root'
})
export class EpbtFaSmartviewsService {

  isSmartviews: boolean = false;

  constructor(private client: FieldAgentClient,
    private router: Router, private faService: EpbtFieldAgentService) {
    // this.LoadSmartViews();

  }
  public fromPage: string;

  //List of selected folder item 
  public selectedFolderItem: any;

  //select product item for details screen
  public selectSmartViewColumnsData: any;

  public selectedGridData: any;

  public smartviewId: number;

  //Smart Views Menu Preparation Start
  folderdata: any;
  SubFolders: SmartView[] = [];
  webTrackUser: any;
  public treeNodes: IEpShellMenuPanelModel[] = [];
  nodes: IEpShellMenuPanelModel[] = [];
  MainFolder: any;
  parentFolder: any;
  subFolder: any;
  isFolderExist: boolean = false;
  menus: any[] = [];
  columns: SmartViewColumn[] = [];

  public isShowChildGrid = false;
  public smartViewDetailsHeaderTitle: string;
  public selectedDashboardId: number;

  LoadSmartViews(webTrackUser, subscribe: (menus: any[]) => void) {
    // this.faService.getBisTrackSetting((bisTrackSetting: any) => {
    //   this.faService.getWebTrackUser((webTrackUser: any) => {
    var folderNames = [];
    this.client.getSmartViewsForUser(webTrackUser).subscribe(res => {
      this.folderdata = res;

      // if (this.treeNodes.length != 0) {
      //   var nodes = this.prepareDataForMenu(res);
      //   //this.addNode(nodes);
      // }
      // else {
      //   this.treeNodes = this.prepareDataForMenu(res);;
      //   this.menus = this.treeNodes;
      // }
      subscribe(this.prepareDataForMenu(res));
      //   });
      // });
    });
  }



  prepareFolders(folders, index): string {
    let folder = folders[0];
    for (let i = 1; i <= index; i++) {
      folder += "/" + folders[i];
    }
    return folder;
  }

  prepareDataForMenu(folders: any[]): any {

    let mainParent = "SmartViews";
    this.menus.push({
      id: 'SmartViews',
      parentId: '',
      link: '',
      caption: 'Smart Views',
      icon: ''
    });

    if (folders && folders.length > 0) {
      folders.forEach(item => {
        if (item.groupName == "") {
          this.menus.push({
            id: item.smartViewID,
            parentId: mainParent,
            link: '/home',
            //link: '/home/smartviews/list',
            caption: item.name,
            icon: '',
            type: 'SmartView'
          });
        }
        else {
          var folderNames = item.groupName.split('\\');
          if (folderNames && folderNames.length > 1) {
            let isItem = false;
            for (let index = 1; index <= folderNames.length; index++) {
              this.subFolder = mainParent + "/" + this.prepareFolders(folderNames, folderNames.length - index);
              this.parentFolder = (folderNames.length - index) != 0 ? mainParent + "/" + this.prepareFolders(folderNames, (folderNames.length - index) - 1) : mainParent;

              this.isFolderExist = this.menus.findIndex(x => x.id == this.subFolder) > 0 ? true : false;
              if (!this.isFolderExist) {
                this.menus.push({
                  id: this.subFolder,
                  parentId: this.parentFolder,
                  link: '',
                  caption: folderNames[folderNames.length - index],
                  icon: '',
                });
                if (!isItem) {
                  this.menus.push({
                    id: item.smartViewID,
                    parentId: this.subFolder,
                    link: '/home',
                    caption: item.name,
                    icon: '',
                    type: 'SmartView'
                  });
                  isItem = true;
                }
              } else {
                if (!isItem) {
                  this.menus.push({
                    id: item.smartViewID,
                    parentId: this.subFolder,
                    link: '/home',
                    caption: item.name,
                    icon: '',
                    type: 'SmartView'
                  });
                  isItem = true;
                }
              }
            }
          }
          else {
            this.parentFolder = mainParent;
            this.subFolder = mainParent + "/" + folderNames[folderNames.length - 1];
            this.isFolderExist = this.menus.findIndex(x => x.id == this.subFolder) > 0 ? true : false;
            if (!this.isFolderExist) {
              this.menus.push({
                id: this.subFolder,
                parentId: this.parentFolder,
                link: '',
                caption: folderNames[folderNames.length - 1],
                icon: '',
              });
              this.menus.push({
                id: item.smartViewID,
                parentId: this.subFolder,
                link: '/home',
                caption: item.name,
                icon: '',
                type: 'SmartView'
              });
            } else {

              this.menus.push({
                id: item.smartViewID,
                parentId: this.subFolder,
                link: '/home',
                caption: item.name,
                icon: '',
                type: 'SmartView'
              });
            }
          }
        }
      });
    }
    console.log("menus", this.menus);
    return this.menus;
  }


  //Smart Views Menu Preparation Start

  //Details Data mapping is Start


  public supportedLinkedColumnNames: any[] = [
    {
      id: "customerid",
      name: "Customer",
      isVisible: false
    },
    {
      id: "customercontactid",
      name: "Customer contact",
      isVisible: false
    },
    {
      id: "creditnoteid",
      name: "Credit note",
      isVisible: false
    },
    {
      id: "customernotepadid",
      name: "Customer notepad",
      isVisible: false
    },
    {
      id: "invoiceid",
      name: "Invoice",
      isVisible: false
    },
    {
      id: "opportunityid",
      name: "Opportunity",
      isVisible: false
    },
    {
      id: "orderid",
      name: "Order/Quote/Template",
      isVisible: false
    },
    {
      id: "productid",
      name: "Product",
      isVisible: false
    }

  ];



  setSmartViewDetailsHeader(dashboardId: number, selectedItem: any) {
    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.client.getSmartViewsForUser(webTrackUser).subscribe(res => {
        if (res != null) {
          var headerTitle = res.find(d => d.smartViewID == dashboardId);
          this.smartViewDetailsHeaderTitle = headerTitle.name + ' - ' + selectedItem.key1 + ' ' + selectedItem.value1;
        }
      });
    });
  }

  keys(obj) {
    return Object.keys(obj);
  }
}
